
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RegistrationPending from './Tabs/RegistrationPending';
import RegistrationApproved from './Tabs/RegistrationApproved';
import RegistrationReject from './Tabs/RegistrationReject';
import { useDispatch } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import RegistrationReApproval from './Tabs/RegistrationReApproval';


function RegistrationApproval() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(setHeaderName("Registration Approval"));
        dispatch(setSubHeaderName());
    }, [dispatch]);

    const renderTabContent = () => {
        switch (value) {
            case 0:
                return <RegistrationPending />;
            case 1:
                return <RegistrationApproved />;
            case 2:
                return <RegistrationReject />;
            case 3:
                return <RegistrationReApproval />;

            default:
                return null;
        }
    };

    return (
        <div>
            <Box
                sx={{
                    maxWidth: { xs: 320, sm: "100%", md: "100%" },
                    bgcolor: 'background.paper', color: "#C38F51", p: 1
                }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable auto tabs example"
                    sx={{ '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" } }}
                    TabIndicatorProps={{
                        style: {
                            mt: 0,

                            backgroundColor: '#C38F51',
                            height: '3px', // Adjust the thickness of the bottom border
                        },
                    }}
                >
                    {["Pending", "Approved", "Rejected","Re-Approval"].map(
                        (label, index) => (
                            <Tab
                                key={label}
                                label={label}
                                sx={{
                                    marginRight: "20px",
                                    '.MuiButtonBase-root-MuiTab-root.Mui-selected ': { color: "#C38F51" },
                                    fontSize: "16px",
                                    color: value === index ? '#C38F51' : 'black',
                                    textTransform: 'none',
                                    fontWeight: value === index ? 'bold' : 'normal',
                                    borderBottom:
                                        value === index ? '3px solid #C38F51' : 'none',
                                    // minWidth: 100, // Ensures tabs have a minimum width  transition: 'color 0.3s ease', // Smooth transition for color change
                                    '&.Mui-selected': {
                                        color: '#C38F51', // Ensures proper application for the selected tab
                                    },
                                    '&:hover': {
                                        color: '#C38F51', // Hover effect for unselected tabs
                                    },
                                }}
                            />
                        )
                    )}
                </Tabs>
            </Box>
            <Box sx={{ py: 2 }}>{renderTabContent()}</Box>
        </div >
    );
}

export default RegistrationApproval;
